import React from "react";
import styled from "styled-components";

export const InlineLoading = (props) => <Spinner {...props}>
    <Bounce1 />
    <Bounce2 />
    <Bounce3 />
</Spinner>;

const Spinner = styled.div`
text-align: center;
`;

const Bounce = styled.div`
width: 18px;
height: 18px;
background-color: rgb(180, 180, 180);
border-radius: 100%;
display: inline-block;
animation: sk-bouncedelay 1.4s infinite ease-in-out both;

@-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}

`;


const Bounce1 = styled(Bounce)`
-webkit-animation-delay: -0.32s;
animation-delay: -0.32s;
`;
const Bounce2 = styled(Bounce)`
-webkit-animation-delay: -0.16s;
animation-delay: -0.16s;
`;
const Bounce3 = Bounce;
